import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvestment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 135,
	height: 135,
	viewBox: "0 0 135 135",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M67.7706 19.6406V29.3053M67.7706 69.3444V79.009M80.7517 62.3878L84.878 66.5298M54.1621 35.5182L50.0358 31.3762M47.513 48.953H36.5095M87.4007 48.953H98.4043M54.1621 62.3878L50.0358 66.5298M80.7517 35.5182L84.878 31.3762",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5623 97.9576L45.0211 82.3139L62.434 87.7552L83.8653 80.2734L91.2323 86.3949L98.5993 84.3544L105.297 89.7957L109.985 87.7552L117.352 93.1965L72.48 115.642L38.3238 108.16L30.9568 113.601L17.5623 97.9576Z",
			fill: "#63688B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.067 97.2775L79.1772 102.719L79.4643 98.6378M62.434 87.7552L45.0211 82.3139L17.5623 97.9576L30.9568 113.601L38.3238 108.16L72.48 115.642L117.352 93.1965L109.985 87.7552L105.297 89.7957M62.434 87.7552L83.8653 80.2734L91.2323 86.3949M62.434 87.7552L74.4891 91.5223M91.2323 86.3949L74.4891 91.5223M91.2323 86.3949L98.5994 84.3544L105.297 89.7957M74.4891 91.5223L79.847 93.1965L79.4643 98.6378M105.297 89.7957L79.4643 98.6378",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 56.457,
			y: 38.3242,
			width: 22,
			height: 22,
			rx: 1,
			stroke: "#C9D8FC",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.5007 47.0699C70.3633 46.1987 69.2789 44.4029 67.412 44.4566M67.412 44.4566C65.5452 44.5102 64.2651 45.7298 64.1862 46.9359C64.1176 47.9857 64.6579 49.8173 67.4121 49.8173C70.1575 49.8173 70.638 51.5373 70.5007 52.4307C70.3566 53.3689 69.7731 54.9771 67.4121 54.9771M67.412 44.4566V42.7812M67.4121 54.9771C65.051 54.9771 64.2777 53.1455 64.1862 52.2297M67.4121 54.9771L67.412 56.6523",
			stroke: "#C9D8FC",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgInvestment;
